/** Normalize city names for filtering (Bombay ↔ Mumbai, case-insensitive). */
export function normalizeCityKey(city) {
  const c = (city || '').trim().toLowerCase();
  if (c === 'bombay') return 'mumbai';
  return c;
}

export function citiesMatch(a, b) {
  if (!a || !b) return false;
  return normalizeCityKey(a) === normalizeCityKey(b);
}
